// JOBE-0106: SubTabNav — horizontal nav under the header with counter
// chips. Six tabs: Overview / Tasks / Documents / Entities / Activity /
// Settings. Active tab from `?tab=` URL param per Decision 2.

import React from 'react';

export const SUB_TABS = [
  { name: 'overview', label: 'Overview' },
  { name: 'tasks', label: 'Tasks', countsKey: 'tasks' },
  { name: 'documents', label: 'Documents', countsKey: 'documents' },
  { name: 'entities', label: 'Entities', countsKey: 'entities' },
  { name: 'activity', label: 'Activity' },
  { name: 'settings', label: 'Settings' },
];

function entitiesTotal(counts) {
  const ebk = counts?.entities_by_kind;
  if (!ebk) return 0;
  return Object.values(ebk).reduce((a, b) => a + (typeof b === 'number' ? b : 0), 0);
}

function chipFor(tab, counts) {
  if (!tab.countsKey || !counts) return null;
  if (tab.countsKey === 'entities') return entitiesTotal(counts);
  const v = counts[tab.countsKey];
  return typeof v === 'number' ? v : null;
}

export function SubTabNav({ activeTab, counts, onSelectTab }) {
  return (
    <nav
      className="project-subtab-nav"
      role="tablist"
      aria-label="Project sub-tabs"
      data-testid="project-subtab-nav"
    >
      {SUB_TABS.map((tab) => {
        const isActive = tab.name === activeTab;
        const count = chipFor(tab, counts);
        return (
          <button
            key={tab.name}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`subtab-button ${isActive ? 'subtab-active' : ''}`}
            onClick={() => onSelectTab(tab.name)}
            data-testid={`subtab-${tab.name}`}
          >
            <span className="subtab-label">{tab.label}</span>
            {count !== null ? (
              <span className="subtab-count mono"> {count}</span>
            ) : null}
          </button>
        );
      })}
    </nav>
  );
}
